import { render, staticRenderFns } from "./ListProfileGroup.vue?vue&type=template&id=68e39c1f"
import script from "./ListProfileGroup.vue?vue&type=script&lang=js"
export * from "./ListProfileGroup.vue?vue&type=script&lang=js"
import style0 from "./ListProfileGroup.vue?vue&type=style&index=0&id=68e39c1f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports